const defaultTextValues = {
  sectionTitle: {
    en: 'Gallery'
  },
  imageOneHeader: {
    en: 'Image One'
  },
  imageTwoHeader: {
    en: 'Image Two'
  },
  imageThreeHeader: {
    en: 'Image Three'
  },
  imageOneParagraph: {
    en: 'Image description'
  },
  imageTwoParagraph: {
    en: 'Image description'
  },
  imageThreeParagraph: {
    en: 'Image description'
  }
};

export default defaultTextValues;
